<div class="welby__loading-container">
  <h2>Loading</h2>
  <div class="flex-container">
    <div class="dot dot--basic"></div>
    <div class="dot dot--basic"></div>
    <div class="dot dot--basic"></div>
    <div class="dot dot--basic"></div>
  </div>
</div>
